import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

type PendingPlanEntryDialogProps = {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  onConfirm?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
};

export function PendingPlanEntryDialog({
  open,
  title = 'Info',
  message,
  onClose,
  onConfirm = onClose,
  confirmLabel = 'OK',
  cancelLabel,
}: PendingPlanEntryDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }

        onClose();
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ fontWeight: 700, backgroundColor: '#ececec' }}>{title}</DialogTitle>
      <DialogContent sx={{ backgroundColor: '#ececec', paddingTop: '20px !important' }}>
        <Typography sx={{ color: '#4b5563' }}>{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ padding: '0 24px 24px', backgroundColor: '#ececec' }}>
        {cancelLabel && (
          <Button variant="text" className="modal-no-btn" onClick={onClose}>
            {cancelLabel}
          </Button>
        )}
        <Button variant="contained" className="modal-yes-btn" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
